import { jsx as _jsx } from 'react/jsx-runtime.js';
import { DialogDismissButton, Flex } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
export const CloseModalButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (_jsx(Flex, { flxJustify: "flex-end", sx: {
            position: 'relative',
            zIndex: 'zIndex20',
        }, children: _jsx(DialogDismissButton, { a11yLabel: t('loginregistration.fullscreenModalContent.closeDialog.a11yLabel'), onClick: onClick, mt: ['spaceS2', 'spaceM', 'spaceM'], mr: ['spaceS2', 'spaceM', 'spaceS2'], sx: {
                position: 'absolute',
                zIndex: 'zIndex10',
                '& > span > span > span': {
                    width: ['23px', '32px', '32px'],
                    height: ['23px', '32px', '32px'],
                },
            } }) }));
};
//# sourceMappingURL=CloseModalButton.js.map